<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    <button
      type="button"
      class="btn btn-primary"
      *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION', 'DIRECTION+']"
      (click)="openCreateModal()"
      >
      Ajouter un document
    </button>
  </div>
  <div class="row mt-2">
    <div class="col-12 px-0">
      <table class="table table-striped table-hover" aria-describedby="documentsTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" sortable="title" (sort)="onSort($event)">Titre</th>
            <th scope="col" sortable="importDate" (sort)="onSort($event)">Date d'import</th>
            <th scope="col" sortable="importedBy" (sort)="onSort($event)">Utilisateur</th>
            <th scope="col" sortable="filename" (sort)="onSort($event)">Nom du fichier</th>
            <th scope="col" class="text-center"></th>
          </tr>
        </thead>
        <tbody>
          @for (document of documents.items; track document) {
            <tr>
              <td></td>
              <td>
                {{ document.titleLabel }}
                @if (document.titleId === smsTitleId) {
                  @switch (adaptDeliveryStatus(document.deliveryStatus)) {
                    @case ('RUNNING') {
                      <span class="ps-2" [ngbTooltip]="document.deliveryResult">
                        <fa-icon class="text-muted" [icon]="['far', 'clock']"></fa-icon>
                      </span>
                    }
                    @case ('FAILED') {
                      <span class="ps-2" [ngbTooltip]="document.deliveryResult">
                        <fa-icon class="text-danger" [icon]="['far', 'times-circle']"></fa-icon> </span
                        >
                      }
                      @case ('DONE') {
                        <span class="ps-2" [ngbTooltip]="document.deliveryResult">
                          <fa-icon class="text-success" [icon]="['far', 'check-circle']"></fa-icon> </span
                          >
                        }
                      }
                    }
                  </td>
                  <td>{{ document.importDate | date }}</td>
                  <td>{{ document.importedBy }}</td>
                  <td>
                    <a [routerLink]="[]" (click)="download(document)">{{ document.fileName }}</a>
                  </td>
                  <td class="text-center">
                    <button
                      type="button"
                      (click)="deleteDocument(document.id)"
                      class="btn btn-sm btn-primary"
                      ngbTooltip="Supprimer"
                      placement="left"
                      *appProfilePerimeter
                      >
                      <fa-icon class="d-block" icon="trash-alt"></fa-icon>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
          @if (documents.items.length === 0) {
            <p class="ms-3">Le bénéficiaire n'a aucun document.</p>
          }
        </div>
      </div>
      <div class="d-flex justify-content-between">
        <ngb-pagination
          [collectionSize]="documents.totalItems"
          [page]="documents.options.page"
          [pageSize]="documents.options.limit"
          (pageChange)="changePage($event)"
          >
        </ngb-pagination>
        <select class="w-auto form-select" [ngModel]="documents.options.limit" (change)="changeLimit($event)">
          <option [value]="10">10 éléments par page</option>
          <option [value]="25">25 éléments par page</option>
          <option [value]="50">50 éléments par page</option>
          <option [value]="100">100 éléments par page</option>
        </select>
      </div>
    </div>
